/* @flow */
import { connect } from 'react-redux'

import Footer from './FooterCore'

export default connect()(Footer)
